import { ApplicationState } from '@app/store'
import {
  actionCreators,
  IGlobalPropertiesState,
  selectPropertyList,
} from '@app/store/modules/global'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { AssociatedPropertiesSelector } from '../components/AssociatedPropertiesSelector'

export default connect(
  createStructuredSelector<ApplicationState, IGlobalPropertiesState>({
    properties: selectPropertyList(),
  }),
  actionCreators,
)(AssociatedPropertiesSelector)
